<div class="title">
  <div class="coldx ">
      <h4> campo personalizzato</h4>
  </div>
</div>
  <div class="row bg-light p-row">
    <div
      comboModInput
      class="col-sm-4"
      [labelInput]="'Campo personalizzato'"
      [optionsCombo]="metadata"
      [labelOption]="'name'"
      (onReturn)="selectedMetadato($event)"
      [mandatory]="true"></div>
     <!--  <app-metadata-dynamic-form [metadataList]="metadataSelected" [size]="4"></app-metadata-dynamic-form> -->
  </div>
